import { combineEpics } from "redux-most";
import applicationEpic from "application/applicationEpic";
import submissionEpic from "submission/submissionEpic";
import introEpic from "intro/introEpic";
import basicDetailsEpic from "basic-details/basicDetailsEpic";
import uploadEpic from "upload/uploadEpic";
import detailsEpic from "file-details/fileDetailsEpic";
import termsEpic from "terms/termsEpic";

export default combineEpics([
  applicationEpic,
  submissionEpic,
  introEpic,
  basicDetailsEpic,
  uploadEpic,
  detailsEpic,
  termsEpic,
]);
